import type { ControlInspector } from "./types"

export const toggleSwitch: ControlInspector<"toggleSwitch"> = {
  Inspector: () => null,
}
